import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faUserGear } from '@fortawesome/free-solid-svg-icons';
import { faAddressCard } from '@fortawesome/free-regular-svg-icons';
import { ListItem, UList, Link, Span } from '../../../../elements';
import styled from 'styled-components';
import { Colors, FontSize } from '../../../../../assets';

interface NavigationProps {
  hide: boolean;
}

interface NavigationSection {
  icon: JSX.Element;
  title: string;
  path?: string;
  subItems?: NavigationSubItem[];
}

interface NavigationSubItem {
  title: string;
  path: string;
}

const navigationSections: NavigationSection[] = [
  {
    icon: <FontAwesomeIcon icon={faAddressCard} />,
    title: 'Zemřelí',
    path: '/protocol-list',
    subItems: [
      { title: 'Soupis protokolů', path: '/protocol-list' },
      { title: 'Nový zemřelý', path: '/deceased' }
    ]
  },
  {
    icon: <FontAwesomeIcon icon={faUserGear} />,
    title: 'Správa',
    path: '/management',
    subItems: [
      { title: 'Správa číselníků', path: '/management/codebooks' },
      { title: 'Správa uživatelů', path: '/management/users' },
      { title: 'Správa protokolových řad', path: '/management/protocol-sequences' }
    ]
  },
  {
    icon: <FontAwesomeIcon icon={faChartLine} />,
    title: 'Statistiky',
    path: '/statistics'
  }
  // {
  //   icon: <FontAwesomeIcon icon={faGear} />,
  //   title: 'Nastavení',
  //   path: '/settings',
  //   subItems: [{ title: 'Role', path: '/settings/roles' }]
  // }
];

const NavigationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.875rem;
  font-size: ${FontSize.normal};
  font-weight: 600;
  color: ${Colors.white};
  margin-bottom: 0.5rem;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 0;
    background-color: ${Colors.orange};
    border-radius: 0 2px 2px 0;
    transition: height 0.3s ease;
  }

  &:hover {
    color: ${Colors.orange};
    background-color: rgba(255, 255, 255, 0.1);

    &::before {
      height: 60%;
    }
  }

  svg {
    font-size: ${FontSize.subTitle};
  }
`;

const SubItemsList = styled.ul`
  list-style: none;
  padding-left: 2.75rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.375rem !important;
`;

const SubItemLink = styled(Link)`
  font-size: ${FontSize.small} !important;
  color: ${Colors.lightText};
  text-decoration: none;
  padding: 0.375rem 0.5rem;
  border-radius: 6px;
  transition: all 0.3s ease;
  display: block;
  font-weight: 400;

  &:hover {
    color: ${Colors.white};
    background-color: rgba(255, 255, 255, 0.08);
    padding-left: 0.75rem;
  }
`;

export const Navigation: React.FC<NavigationProps> = ({ hide }) => {
  return (
    <>
      {hide ? (
        <UList>
          {navigationSections.map((section, index) => (
            <ListItem key={index}>
              {section.path ? (
                <Link to={section.path}>{section.icon}</Link>
              ) : (
                <span>{section.icon}</span>
              )}
            </ListItem>
          ))}
        </UList>
      ) : (
        <NavigationContainer>
          {navigationSections.map((section, index) => (
            <SectionContainer key={index}>
              {section.path ? (
                <Link to={section.path}>
                  <SectionTitle>
                    {section.icon}
                    <Span>{section.title}</Span>
                  </SectionTitle>
                </Link>
              ) : (
                <SectionTitle>
                  {section.icon}
                  <Span>{section.title}</Span>
                </SectionTitle>
              )}
              {section.subItems && (
                <SubItemsList>
                  {section.subItems.map((subItem, subIndex) => (
                    <li key={subIndex}>
                      <SubItemLink to={subItem.path}>{subItem.title}</SubItemLink>
                    </li>
                  ))}
                </SubItemsList>
              )}
            </SectionContainer>
          ))}
        </NavigationContainer>
      )}
    </>
  );
};
